
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    // Initial value based on window width if in browser environment
    if (typeof window !== 'undefined') {
      return window.innerWidth < MOBILE_BREAKPOINT
    }
    return false
  })

  React.useEffect(() => {
    // More efficient media query listener with better performance
    const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    
    // Set initial value based on media query
    setIsMobile(mediaQuery.matches)
    
    // Use the more efficient matchMedia API for listening to screen size changes
    const handleResize = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches)
    }
    
    // Add event listener using modern API with fallback
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleResize)
    } else {
      // Fallback for older browsers
      mediaQuery.addListener(handleResize)
    }
    
    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleResize)
      } else {
        // Fallback cleanup
        mediaQuery.removeListener(handleResize)
      }
    }
  }, [])

  return isMobile
}
